import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { CapacityResultEntity } from '../../../domain/entities/capacity-result.entity';
import { TeamWorkloadRepository } from '../../../infrastructure/repositories/team-workload.repository';
import { UpsertCapacityCommand } from './upsert-capacity.command';

@Injectable({ providedIn: 'root' })
export class UpsertCapacityUseCase {
  private readonly _repository = inject(TeamWorkloadRepository);

  public execute(command: UpsertCapacityCommand): Observable<CapacityResultEntity> {
    return this._repository.upsertCapacity(command.userId, {
      baseCapacity: command.baseCapacity,
      temporaryCapacity: command.temporaryCapacity,
      temporaryCapacityExpiresOn: command.temporaryCapacityExpiresOn,
      isSaveAnywayOverride: command.isSaveAnywayOverride,
    });
  }
}
